import api from "../../services/clinicsApi";

export interface Concept {
    id: number;
    name: string;
    default_price: number;
    default_tax_rate: number;
}

export interface InvoiceLine {
    id?: number;
    concept_id?: number | null;
    concept_name: string;
    quantity: number;
    unit_price: number;
    tax_rate: number;
    total: number;
}

export interface Invoice {
    id: number;
    invoice_number?: string;
    patient_id: number;
    patient_name?: string;
    issue_date: string;
    type: string;
    status: string;
    subtotal: number;
    total: number;
    gcs_pdf_url?: string;
    created_at: string;
    lines: InvoiceLine[];
}

export const invoicesApi = {
    getInvoices: async (): Promise<Invoice[]> => {
        const response = await api.get('/invoices');
        return response.data;
    },
    
    getConcepts: async (): Promise<Concept[]> => {
        const response = await api.get('/invoices/concepts');
        return response.data;
    },
    
    createInvoice: async (invoice: any): Promise<Invoice> => {
        const response = await api.post('/invoices', invoice);
        return response.data;
    },
    
    emitInvoice: async (id: number): Promise<Invoice> => {
        const response = await api.post(`/invoices/${id}/emit`);
        return response.data;
    },
    
    deleteInvoice: async (id: number): Promise<void> => {
        await api.delete(`/invoices/${id}`);
    },

    downloadInvoicePdf: async (id: number): Promise<Blob> => {
        const response = await api.get(`/invoices/${id}/pdf`, {
            responseType: 'blob'
        });
        return response.data;
    }
};
